import { isArray } from "@omnia/shared/utils/utils"
import { CroppingGroup } from "./menu";
import { CroppingVm } from "./cropping";

export function hasAuthorizationsOnAnyInGroup(group: CroppingGroup | CroppingVm[]) {

    const array = isArray(group)
        ? group
        : group?.cropping

    return array?.some(c => c.authorized)

}


export function canEditGroupRequirements(group: CroppingGroup) {
    return group.cropping
        && hasAuthorizationsOnAnyInGroup(group)
        && group.cropping.some(c => c.hasRequirements)
        && group.cropping.filter(c => c.selected).length === group.cropping.filter(c => c.selected && c.hasRequirements).length;
}
